import { createAsyncThunk } from "@reduxjs/toolkit";
import { DASHBOARD } from "constants/api";
import axios from "utils/http";

export interface IDashboardSummaryResponse extends ApiResponse {
  data: IDashboardSummary;
}

export const fetchDashboardSummary = createAsyncThunk(
  DASHBOARD.SUMMARY,
  async ({ onFailure }: ReduxAction, { rejectWithValue }) => {
    try {
      const { data }: IDashboardSummaryResponse = await axios.get(
        DASHBOARD.SUMMARY
      );
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);
